<script setup lang="ts">
import DashboardCard from "./DashboardCard.vue"

withDefaults(
  defineProps<{
    eyebrow?: string
    title: string
    variant?: "dark" | "pale" | "warning" | "danger"
  }>(),
  {
    eyebrow: "",
    variant: "dark"
  }
)
</script>

<template>
  <DashboardCard :eyebrow="eyebrow" :title="title" :variant="variant" static>
    <slot />
  </DashboardCard>
</template>
